import type { IconData } from '@stacksjs/iconify-core'

export const otherUiWrench: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 6.5a6.5 6.5 0 0 1-8.64 6.14L4 16l-4-4l3.36-3.36A6.5 6.5 0 0 1 12.345.655L9 4v3h3l3.346-3.346c.419.86.654 1.825.654 2.846\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiWrench
